// Self-hosted fonts (no runtime Google Fonts request)
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import '@fontsource/fira-code/400.css';
import '@fontsource/fira-code/500.css';

import 'prismjs/themes/prism.css';
import './src/styles/global.css';

// Add a "Copy" button to every code block after each route render.
export const onRouteUpdate = () => {
  if (typeof document === 'undefined') return;

  const addButtons = () => {
    document.querySelectorAll('pre[class*="language-"]').forEach((pre) => {
      if (pre.querySelector('.copy-btn')) return;
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'copy-btn';
      btn.textContent = 'Copy';
      btn.addEventListener('click', () => {
        const code = pre.querySelector('code');
        const text = (code || pre).innerText;
        navigator.clipboard.writeText(text).then(
          () => {
            btn.textContent = 'Copied';
            setTimeout(() => {
              btn.textContent = 'Copy';
            }, 1500);
          },
          () => {
            btn.textContent = 'Error';
          }
        );
      });
      pre.appendChild(btn);
    });
  };

  // Defer so the markdown HTML is in the DOM.
  setTimeout(addButtons, 0);
};
